const colorPalette = {
	primary: {
		main: '#8a01b7',
	},
	secondary: {
		main: '#333',
	},
	error: {
		main: '#ff3f3f',
	},
	text: {
		main: '#333',
		light: '#333',
		dark: '#ddd',
	},
};

export default colorPalette;
